<div class="customer-detail" [ngClass]="domainData?.domain">
  <f-data-card *ngIf="domainName != 'about'">
    <button (click)="cusAccService.refreshDomain()" mat-button color="primary" title="Refresh" class="btn-refresh"   >
      <i class="fa-solid fa-arrows-rotate"></i>
    </button>
    <div class="flex justify-space-between peekaboo-links">
      <h4>{{ domainName }}</h4>
      <f-button [iconConfig]="iconConfig" class="btn-kc-links" text="Supporting Links" title="Supporting Links" type="button"
        variant="action" (click)="openKcLinks()">
      </f-button>
    </div>
    <section *ngIf="!domainData && domainErrMsg != 'NA'" class="error-wrapper">
      <f-alert variant="error">
        <p>
          {{ domainErrMsg }}
        </p>
      </f-alert>
    </section>

    <app-loader *ngIf="cusAccService.domainLoader" [loaderType]="loaderType" [loaderMsg]="cusAccService.showLoaderMsg">
    </app-loader>

    <div class="row">
      <div class="left-panel">
        <ul class="card-list">
          <li *ngFor="let x of domainData?.topics"
            [ngClass]="{ 'tab-active': currentSection == x.id && x?.linkEnable }">
            <button class="navlinks" (click)="onAnchorClick(x.id, subscriptions)"
              [ngClass]="{'linkDisabled':!x?.linkEnable}" [disabled]="!x?.linkEnable">
              <i [ngClass]="x.icon"></i>
              {{ x.heading }}</button>
          </li>
        </ul>
      </div>
      <div class="right-panel" #subscriptions>
        <div class="container form" *ngFor="let topic of domainData?.topics; let last = last ">
          <div *ngFor="let group of topic.groups;" id="{{ topic.id }}"
            [className]="currentSection == topic.id  && topic?.linkEnable ? 'show' : 'hide'">
            <div class="row" *ngIf="group?.subgroups?.length == 0">
              <div class="col-md-12" *ngIf="group.heading">
                <h5 class="subheading" [ngClass]="group.stylegroup" id="{{ group.id }}">
                  {{ group.heading }} {{ resetdivision()}}
                </h5>
              </div>
            </div>

            <section *ngIf="group.subgroups?.length == 0 && showErrMsgForTopic(group)" class="error-wrapper">
              <f-alert variant="{{group?.topicErrMsg ==noDataMsg?'warning':'error'}}">
                <p>
                  {{ group?.topicErrMsg }}
                </p>
              </f-alert>
            </section>

            <div *ngIf="group.subgroups?.length != 0">
              <div *ngFor="let subgroup of group.subgroups; let last = last; ">
                <div class="row inner-row " [ngClass]="group?.stylegroup">

                  <div class="col-md-12" *ngIf="group.heading">
                    <h6 class="subheading" id="{{ group.id }}">
                      {{ group.heading }}
                    </h6>
                  </div>

                  <ng-container *ngFor="let section of subgroup?.sections; let i=index">
                    <div *ngIf="sectionChange(section.division)" class="row-divider">
                    </div>

                  <!-- start of table structure data -->
                  <!-- <div class="row-divider section-gap"></div> -->
                  
                  <!-- <div class="row inner-row" *ngIf="isRuleTableType(section)">
                    <div class="col-md-12">
                    <h5 class="subheading">
                      Balance Due/Overpayment Summary
                    </h5>
                  </div>
                  </div> -->

                    <div class="col-md-12" *ngIf="isRuleTableType(section)">
                     
                   <table class="section-table" aria-label="Table Type Plan Data">
                        <tr>
                          <th *ngFor="let col of section?.subSectionTable?.columns">{{ col?.header }}</th>
                        </tr>
                        <tr  *ngFor="let row of section?.subSectionTable?.rows">
                          <td *ngFor="let col of section?.subSectionTable?.columns">
                              {{ row[col?.fieldName] }}
                          </td>
                          </tr>
                         
                      <tr *ngIf="(section?.subSectionTable?.rows?.length ?? 0) === 0 && !showErrMsgForTopic(section)">
                        <td class="empty-state-cell" [attr.colspan]="section?.subSectionTable?.columns?.length || 1">
                          <section class="error-wrapper">
                            <f-alert variant="warning">
                              <p>There is no data available.</p>
                            </f-alert>
                          </section>
                        </td>
                      </tr>

                  </table>

              <section *ngIf="section?.subSectionTable?.rows?.length == 0 && showErrMsgForTopic(section)" class="error-wrapper">
                <f-alert variant="{{section?.topicErrMsg == noDataMsg?'warning':'error'}}">
                <p>
                  {{ section?.topicErrMsg }}
                </p>
              </f-alert>
            </section>
                    </div>
                  <!-- End of table data structure  -->

                    <div class="col-lg-25" [ngClass]="group?.stylegroup"
                      *ngIf="section.sectionsubgroups?.length <= 1  && !section?.rowflag">
                      <div *ngFor="let subsection of section.sectionsubgroups">
                        <div *ngFor="let element of subsection.elements">
                          <span class="form-label {{ element.stylekey }}" *ngIf="!element.hyperlink && element.key"
                            title="{{element?.title}}">
                            {{ element.key }}
                          </span>
                          <button mat-button *ngIf="element.hyperlink" color="primary" class="{{
                              element.stylevalue
                                ? element.stylevalue
                                : 'form-link-inquiry'
                            }}">
                            {{ element?.key }}
                          </button>
                          <span *ngFor="let v of element.values">
                            <span *ngIf="v?.value" class="form-value" class="{{ v.stylevalue }}"
                              [innerHTML]="checkForNAValues(v?.value,section.method)">
                              {{ v?.value }}
                            </span>
                          </span>
                        </div>

                      </div>

                    </div>
                    <ng-container *ngIf="section?.sectionsubgroups?.length > 1 || section?.rowflag=='Yes'">
                      <div class="container">
                        <div class="row nested-row" *ngFor="let subsection of section.sectionsubgroups">
                          <div class="col-lg-25" *ngFor="let element of subsection.elements">
                            <span class="form-label {{ element.stylekey }}" *ngIf="!element.hyperlink && element.key">
                              {{ element.key }}
                            </span>
                            <button mat-button *ngIf="element.hyperlink" color="primary" class="{{
                                element.stylevalue
                                  ? element.stylevalue
                                  : 'form-link-inquiry'
                              }}">
                              {{ element?.key }}
                            </button>
                            <span *ngFor="let v of element.values">
                              <span *ngIf="v?.value" class="form-value {{ v.stylevalue }}">
                                {{checkForNAValues(v?.value,section.method)}}
                              </span>
                            </span>
                          </div>

                        </div>
                      </div>
                    </ng-container>

                  </ng-container>
                  <div class="row-divider" *ngIf="!last && domainData?.domain!='COMMON'"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </f-data-card>
  <f-data-card class="pos-relative" *ngIf="domainName == 'about'">
    <button mat-button color="primary" title="Refresh" class="btn-refresh hide">
      <i class="fa-solid fa-arrows-rotate"></i>
    </button>

    <h2 class="heading" *ngIf="errMsg && errMsg != 'NA'">About the Customer</h2>
    <h2 class="heading" *ngIf="errMsg == 'NA'">{{ domainData?.topics[0]?.heading }}</h2>



    <section *ngIf="errMsg && errMsg != 'NA'" class="error-wrapper">
      <f-alert variant="error">
        <p>
          {{ errMsg }}
        </p>
      </f-alert>
    </section>

    <ng-container *ngIf="errMsg == 'NA'">
      <div *ngFor="let group of domainData?.topics[0].groups">
        <h5 class="section-heading" *ngIf="group.subgroups?.length == 0 && group.heading ">
          {{ group?.heading }}
        </h5>

        <section *ngIf="group.subgroups?.length == 0 && showErrMsgForTopic(group)" class="error-wrapper">
          <f-alert variant="{{group?.topicErrMsg ==noDataMsg?'warning':'error'}}">
            <p>
              {{ group?.topicErrMsg }}
            </p>
          </f-alert>
        </section>

        <div class="container form about-customer-section" *ngIf="group.subgroups?.length != 0">
          <div class="row" [ngClass]="group?.stylegroup">
            <div class="col-md-4" *ngFor="let section of group.subgroups[0]?.sections">
              <div *ngFor="let subsection of section.sectionsubgroups">
                <div *ngFor="let element of subsection.elements">
                  <span class="form-label"> {{ element.key }} </span>
                  <span class="form-value">
                    <span *ngFor="let v of element.values">{{checkForNAValues(v?.value,section.method)}} </span></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <app-loader *ngIf="cusAccService.firstLoadLoader" [loaderType]="loaderType"
      [loaderMsg]="cusAccService.showLoaderMsg"></app-loader>

  </f-data-card>
</div>


